<template>
  <div class="curation-block" v-if="ready">
    <div class="section-header">
      <div class="section-title">{{ title }}</div>
    </div>
    <div v-if="layout == 11" class="section-content layout-col-2">
      <product-block
        v-for="(product, i) in products"
        :key="'product' + i"
        v-bind="{ info: product, modifier: 'm', gaEvent: '007' }"
      />
    </div>
    <div v-else class="section-content" :class="{ reverse: layout == 6 }">
      <div class="item-left-l">
        <product-block
          v-bind="{ info: products[0], modifier: 'l', gaEvent: '007' }"
        />
      </div>
      <div class="item-right-s">
        <product-block
          v-bind="{ info: products[1], modifier: 's', gaEvent: '007' }"
        />
        <product-block
          v-bind="{ info: products[2], modifier: 's', gaEvent: '007' }"
        />
      </div>
    </div>
    <router-link
      :to="{
        name: 'curation',
        params: { id: curationGuid },
        query: {},
      }"
      class="touch-area no-blue-highlight"
    >
      <v-btn
        @click="ga"
        color="primary"
        block
        rounded
        outlined
        class="more-link"
      >
        更多商品
      </v-btn>
    </router-link>
  </div>
</template>

<script>
import ProductBlock from '@/components/ProductBlock'
export default {
  name: 'CurationLayout3',
  components: {
    ProductBlock,
  },
  props: {
    layout: {
      type: Number,
      default: 5,
    },
    title: {
      type: String,
      default: '',
    },
    curationGuid: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    ready() {
      return (
        this.title != null &&
        this.curationGuid !== null &&
        this.products != null &&
        this.products.length >= 3
      )
    },
  },
  data: function() {
    return {}
  },
  methods: {
    ga() {
      gtag('event', 'click', {
        event_id: '008',
        location: '首頁',
        event_category: '策展--更多',
        event_label: this.curationGuid,
        value: 8,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.curation-block {
  padding: 24px 4.3%;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);

  .section-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;

    .section-title {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0.56px;
      color: #383838;
      margin-left: 1px;
    }
  }

  .section-content {
    display: flex;
    padding-top: 20px;
    &.layout-col-2 {
      flex-wrap: wrap;
      .product-block {
        width: 50%;
        max-width: 50%;
        padding-bottom: 20px;
        &:nth-child(odd) {
          padding-right: 8px;
        }
        &:nth-child(even) {
          padding-left: 8px;
        }
        &:last-child,
        &:nth-last-child(-n + 2) {
          padding-bottom: 0;
        }
      }
    }
    &.reverse {
      flex-flow: row-reverse;
      .item-left-l {
        padding-right: 0;
        padding-left: 16px;
      }
    }
    .item-left-l {
      padding-right: 16px;
      width: 64.4%;
      flex-grow: 0;
      flex-shrink: 0;
    }

    .item-right-s {
      width: 35.3%;
      flex-grow: 0;
      flex-shrink: 0;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      .product-block:nth-child(even) {
        margin-top: 10px;
      }
    }

    img {
      width: 100%;
    }
  }

  .more-link {
    margin-top: 24px;
  }
}

.touch-area {
  span {
    margin-right: 4px;
  }
}
</style>
